/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orderTypeSchema = z
	.object({
		id: z.uuid(),
		name: z.string(),
		image_link: z
			.string()
			.max(1024)
			.regex(/(?:png|jpg|jpeg|webp|svg|ai)$/)
			.nullable(),
		type: z.string(),
	})
	.describe("Сериализатор для типа заказа (здесь, с собой)");
